<p-confirmDialog></p-confirmDialog>
<div class="pdf-certificate-dialog">
  @if (loadingStatus()) {
    <p class="hint-text">Lade Zertifikatsstatus…</p>
  } @else {
    @if (certificate(); as cert) {
      <h4 class="section-heading">Hinterlegtes Zertifikat</h4>

      <div class="status-panel">
        <dl>
          <dt>Inhaber</dt>
          <dd>
            @if (cert.subject; as subject) {
              {{ commonName(subject) }}
              <span class="distinguished-name">{{ subject }}</span>
            } @else {
              -
            }
          </dd>

          <dt>Gültig bis</dt>
          <dd>{{ cert.expiresAt | date: "dd.MM.yyyy HH:mm" }}</dd>

          <dt>Ursprünglicher Dateiname</dt>
          <dd>{{ cert.originalFileName ?? "-" }}</dd>

          <dt>Hochgeladen am</dt>
          <dd>{{ cert.createdAt | date: "dd.MM.yyyy HH:mm" }}</dd>

          @if (cert.updatedAt) {
            <dt>Zuletzt ersetzt am</dt>
            <dd>{{ cert.updatedAt | date: "dd.MM.yyyy HH:mm" }}</dd>
          }
        </dl>

        <div class="actions">
          <button
            pButton
            type="button"
            label="Entfernen"
            icon="pi pi-trash"
            class="p-button-danger p-button-outlined"
            [disabled]="deleting()"
            [loading]="deleting()"
            (click)="delete()"
          ></button>
        </div>
      </div>

      <h4 class="section-heading">Zertifikat ersetzen</h4>
    } @else {
      <h4 class="section-heading">Zertifikat hinterlegen</h4>
      <p class="hint-text">Es ist noch kein Zertifikat hinterlegt.</p>
    }

    <div class="upload-form">
      <div class="picker">
        <p-fileUpload
          #pfxUpload
          name="pfxFile"
          mode="basic"
          chooseLabel="PFX-Datei auswählen"
          accept=".pfx,.p12"
          [auto]="false"
          invalidFileTypeMessageSummary="{0}: Ungültiger Dateityp"
          invalidFileTypeMessageDetail="Erlaubte Dateitypen: {0}."
          (onSelect)="onPfxFileSelected($event)"
        ></p-fileUpload>
        <!-- p-fileUpload zeigt den Dateinamen nur, solange sein eigener, interner files-Array
             gefüllt bleibt - genau das leert onPfxFileSelected() per clear() bewusst (siehe
             dortiger Kommentar), damit ein erneuter Klick den Dateidialog öffnet statt einen
             kaputten internen Upload auszulösen. Der Name wird deshalb hier separat aus dem
             eigenen State angezeigt, unabhängig vom internen Zustand der Komponente. -->
        @if (pfxFile(); as file) {
          <span class="selected-file-name" [title]="file.name">{{
            file.name
          }}</span>
        }
      </div>

      <div class="picker">
        <p-password
          id="certificateUploadPassword"
          [(ngModel)]="password"
          placeholder="Zertifikat-Passwort"
          [feedback]="false"
          [toggleMask]="true"
          autocomplete="new-password"
        ></p-password>
      </div>

      <div class="actions">
        <button
          pButton
          type="button"
          label="Hochladen"
          icon="pi pi-upload"
          [disabled]="!pfxFile() || !password || uploading()"
          [loading]="uploading()"
          (click)="upload()"
        ></button>
      </div>
    </div>
  }
</div>
